import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@tellescope/design-system";
import type { EnduserObservation } from "@tellescope/types-models";

interface DeleteEntryDialogProps {
  /** The entry pending deletion. Presence of a value IS the dialog's open state. */
  entry: EnduserObservation | undefined;
  onOpenChange: (open: boolean) => void;
  onConfirm: (id: string) => Promise<unknown>;
  isPending: boolean;
}

export const DeleteEntryDialog = ({ entry, onOpenChange, onConfirm, isPending }: DeleteEntryDialogProps) => {
  const { t } = useTranslation("portal");

  return (
    <ConfirmDialog
      open={!!entry}
      onOpenChange={onOpenChange}
      variant="destructive"
      title={t("Delete entry")}
      description={t("This entry will be permanently removed. This action cannot be undone.")}
      confirmText={t("Delete")}
      cancelText={t("Cancel")}
      onConfirm={async () => {
        if (entry) await onConfirm(entry.id);
      }}
      loading={isPending}
    />
  );
};
